




























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import ContributionsGrid from "@/shared/components/contribution/ContributionsGrid.vue";
import ContributionScheduleTabs from "@/shared/components/contributionsV3/ContributionScheduleTabs.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { BankCustodian } from "@/admin/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component ({
  components: {
    ContributionsGrid,
    ContributionScheduleTabs,
    GenericLoadingSpinner
  }
})
export default class ContributionsList extends Vue {
  custodianSettings = useCustodianSettingsStore();

  @Prop()
  activityPage: number;

  @Prop()
  schedulesPage: number;

  @Prop()
  tab: string;

  @Prop()
  page: number;

  @Prop()
  routeToPages: (page: number) => Location;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  mounted () {
    const args: any = { username: this.username, partnerId: this.partnerId };
    this.custodianSettings.getCustodianSettings(args);
  }

  get isLoaded () {
    return this.custodianSettings.isLoaded;
  }

  get displayContributionTabs () {
    return this.custodianSettings.userHsaCustodian === BankCustodian.HsaBank;
  }
}
